package com.anjuros.website.templates.template4.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType
import com.anjuros.website.templates.selection.util.Res


enum class ResKey: ResKeyType {


    TEMPLATE4_SECTION1,
    TEMPLATE4_SECTION2,
    TEMPLATE4_SECTION3,
    TEMPLATE4_SECTION4,
    TEMPLATE4_SECTION5,
    TEMPLATE4_SLOGAN1,
    TEMPLATE4_ABOUT,
    TEMPLATE4_PROJECT1_TITLE,
    TEMPLATE4_PROJECT1_DESC,
    TEMPLATE4_PROJECT2_TITLE,
    TEMPLATE4_PROJECT2_DESC,
    TEMPLATE4_PROJECT3_TITLE,
    TEMPLATE4_PROJECT3_DESC,
    TEMPLATE4_OPEN_GALERY,
    TEMPLATE4_REVIEW1_TITLE,
    TEMPLATE4_REVIEW1,
    TEMPLATE4_REVIEW2_TITLE,
    TEMPLATE4_REVIEW2,
    TEMPLATE4_REVIEW3_TITLE,
    TEMPLATE4_REVIEW3,
    TEMPLATE4_REVIEW4_TITLE,
    TEMPLATE4_REVIEW4,
    TEMPLATE4_REVIEW5_TITLE,
    TEMPLATE4_REVIEW5,
    TEMPLATE4_REVIEW6_TITLE,
    TEMPLATE4_REVIEW6,
    TEMPLATE4_REVIEW7_TITLE,
    TEMPLATE4_REVIEW7,
    TEMPLATE4_REVIEW8_TITLE,
    TEMPLATE4_REVIEW8,
    TEMPLATE4_REVIEW9_TITLE,
    TEMPLATE4_REVIEW9,
    TEMPLATE4_REVIEW10_TITLE,
    TEMPLATE4_REVIEW10,
    TEMPLATE4_CONTACT,
    TEMPLATE4_QUOTE,
    TEMPLATE4_CONTACT_CHECKBOX1,
    TEMPLATE4_CONTACT_CHECKBOX2,
    TEMPLATE4_CONTACT_CHECKBOX3,
    TEMPLATE4_CONTACT_CHECKBOX4,
    TEMPLATE4_CONTACT_CHECKBOX5,
    TEMPLATE4_CONTACT_CHECKBOX6,
    TEMPLATE4_CONTACT_CHECKBOX7,
    TEMPLATE4_CONTACT_CHECKBOX8,
    TEMPLATE4_CONTACT_CHECKBOX9,
    TEMPLATE4_CONTACT_CHECKBOX10,
    TEMPLATE4_CONTACT_CHECKBOX11,
    TEMPLATE4_CONTACT_CHECKBOX12,
    TEMPLATE4_CONTACT_CHECKBOX13,
    TEMPLATE4_CONTACT_CHECKBOX14,
    TEMPLATE4_CONTACT_CHECKBOX15,
    TEMPLATE4_CONTACT_CHECKBOX16,
    TEMPLATE4_CONTACT_CHECKBOX17,
    TEMPLATE4_CONTACT_CHECKBOX18,
    TEMPLATE4_CONTACT_CHECKBOX19,
    TEMPLATE4_CONTACT_CHECKBOX20;

    override val keyName: String
        get() = name


}


// 4. A map to hold all translations, keyed by language
val TextResources = mapOf(
    Language.EN to mapOf(


        ResKey.TEMPLATE4_SECTION1 to "About Me",
        ResKey.TEMPLATE4_SECTION2 to "Projects",
        ResKey.TEMPLATE4_SECTION3 to "Gallery",
        ResKey.TEMPLATE4_SECTION4 to "Testimonial",
        ResKey.TEMPLATE4_SECTION5 to "Contact Me",

        ResKey.TEMPLATE4_SLOGAN1 to "Painter & Decorator",
        ResKey.TEMPLATE4_ABOUT to "Hi, I’m Karl Smith, a painter and decorator with over 10 years of experience. I take pride in delivering high-quality work with a clean finish, whether it’s a single room or a full property makeover. I cover all aspects of painting and decorating - interior, exterior, wallpapering, woodwork, and more." +
                " I’m reliable, tidy, and easy to work with, and I always aim to make the process smooth and stress-free for my clients. Most of my work comes through word of mouth, which I think speaks to the care and detail I put into every job." +
                " When I’m not on-site, I enjoy DIY projects, sketching, and spending time with my family. If you’re looking for someone who’s passionate about making spaces look their best, I’d be happy to help.",

        ResKey.TEMPLATE4_PROJECT1_TITLE to "Kitchen",
        ResKey.TEMPLATE4_PROJECT1_DESC to "Over the years, we’ve transformed countless kitchens, each with its own character and challenges. From refreshing tired walls with crisp, modern colours to updating cabinetry and woodwork with smooth, durable finishes, our focus is always on precision and quality. Whether it’s a full renovation or a simple refresh, a professional paint job can completely change the feel of a kitchen, making it brighter, cleaner, and more inviting. Every project is a chance to bring new life to the heart of the home.",
        ResKey.TEMPLATE4_PROJECT2_TITLE to "Living Room",
        ResKey.TEMPLATE4_PROJECT2_DESC to "Living rooms are where comfort meets style, and we’ve had the pleasure of revamping many to suit all kinds of tastes and homes. Whether it’s creating a bold feature wall, refreshing tired ceilings, or bringing warmth with modern neutral tones, our work helps transform these central spaces. Careful prep and high-quality finishes ensure a clean, polished look that lasts. From classic to contemporary, every makeover is tailored to enhance the atmosphere and make the living room a true reflection of the homeowner’s style.",
        ResKey.TEMPLATE4_PROJECT3_TITLE to "Bedroom",
        ResKey.TEMPLATE4_PROJECT3_DESC to "Bedrooms are personal spaces, and we’ve helped transform many into calm, stylish retreats. Whether it’s soft, soothing tones for a relaxing feel or bold colours to reflect personality, every project starts with careful prep and attention to detail. We refresh walls, ceilings, woodwork, and even built-in wardrobes to give each room a fresh, clean look. With the right paint and finish, a bedroom makeover can completely change the mood of the space, turning it into a place people love to unwind in.",
        ResKey.TEMPLATE4_OPEN_GALERY to "Open Gallery",

        ResKey.TEMPLATE4_REVIEW1_TITLE to "Living Room Repaint",
        ResKey.TEMPLATE4_REVIEW1 to "Karl Smith did a fantastic job repainting our living room. The finish is smooth, edges are crisp, and he helped us choose a modern colour that totally transformed the space. He was punctual, tidy, and respectful throughout the job.",
        ResKey.TEMPLATE4_REVIEW2_TITLE to "Full House Decoration",
        ResKey.TEMPLATE4_REVIEW2 to "We hired Karl to decorate our entire 3-bedroom house, and we couldn’t be happier. From the walls to the skirting boards, everything was done with precision. He’s reliable, honest, and takes real pride in his work.",
        ResKey.TEMPLATE4_REVIEW3_TITLE to "Exterior Painting",
        ResKey.TEMPLATE4_REVIEW3 to "Karl tackled the exterior of our home and it now looks brand new. The paint has held up well despite the weather, and he made sure to prep everything properly before getting started. Excellent attention to detail.",
        ResKey.TEMPLATE4_REVIEW4_TITLE to "Kitchen Repaint",
        ResKey.TEMPLATE4_REVIEW4 to "Our kitchen needed a fresh look and Karl delivered beyond expectations. He suggested a lovely shade, fixed some wall cracks before painting, and worked quickly without sacrificing quality.",
        ResKey.TEMPLATE4_REVIEW5_TITLE to "Bedroom Redecoration",
        ResKey.TEMPLATE4_REVIEW5 to "Karl redecorated our master bedroom and did a brilliant job. From stripping old wallpaper to applying new paint, he kept the place clean and was friendly and approachable throughout.",
        ResKey.TEMPLATE4_REVIEW6_TITLE to "Feature Wall Design",
        ResKey.TEMPLATE4_REVIEW6 to "We asked Karl to create a feature wall in our lounge and it looks amazing. He had creative ideas, kept us involved in the process, and executed it flawlessly. Highly recommend him for bespoke touches.",
        ResKey.TEMPLATE4_REVIEW7_TITLE to "Rental Property Refresh",
        ResKey.TEMPLATE4_REVIEW7 to "Karl repainted our rental flat between tenants and made it look fresh and welcoming. He worked within a tight timeframe and gave us great value for money. A dependable decorator we will use again.",
        ResKey.TEMPLATE4_REVIEW8_TITLE to "Hallway and Stairs",
        ResKey.TEMPLATE4_REVIEW8 to "The hallway and staircase were in rough shape, but Karl made them look immaculate. His work is neat, and he left no mess behind. The colour scheme he recommended really opened up the space.",
        ResKey.TEMPLATE4_REVIEW9_TITLE to "Office Painting Job",
        ResKey.TEMPLATE4_REVIEW9 to "Karl painted our small office space and it has totally changed the feel of the room. He was professional, quick, and worked around our schedule to minimise disruption.",
        ResKey.TEMPLATE4_REVIEW10_TITLE to "Bathroom Ceiling Repair and Paint",
        ResKey.TEMPLATE4_REVIEW10 to "We had some water damage on our bathroom ceiling, and Karl not only repaired the plaster but also gave it a clean, moisture-resistant coat of paint. Great workmanship and friendly service.",

        ResKey.TEMPLATE4_CONTACT to "Contact me!",
        ResKey.TEMPLATE4_QUOTE to "Get a free quote",

        ResKey.TEMPLATE4_CONTACT_CHECKBOX1 to "Living Room",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX2 to "Bedroom",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX3 to "Kitchen",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX4 to "Bathroom",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX5 to "Hallway / Landing",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX6 to "Stairs",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX7 to "Ceiling(s)",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX8 to "Doors & Frames",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX9 to "Skirting Boards",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX10 to "Exterior Walls",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX11 to "Fence / Shed",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX12 to "Entire Property",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX13 to "Painting",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX14 to "Wallpaper Hanging",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX15 to "Wallpaper Removal",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX16 to "Surface Preparation",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX17 to "Crack Repairs",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX18 to "Filling Holes",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX19 to "Woodwork Painting",
        ResKey.TEMPLATE4_CONTACT_CHECKBOX20 to "Exterior Decorating",


        ),
)
